import { useCallback, useMemo, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { captureExceptionEvent } from '@blocs.observability';
import { SUPPORT_URL } from '@blocs.chat-support';
import { PreCancelDoc } from '@minecraft.graphql-operations';
import { useUserContext } from '@blocs.auth';

export const useRetention = () => {
  const apollo = useApolloClient();
  const { subscription } = useUserContext();
  const [loading, setLoading] = useState(false);
  const defaultCancelUrl = SUPPORT_URL;
  const callbackUrl = useMemo(() => {
    return window.location.href.includes('localhost') ? 'https://app.stg.castingnetworks.com' : window.location.href;
  }, []);

  const redirectToRetentionUrl = useCallback(async () => {
    try {
      if (!subscription?.id) {
        return;
      }
      setLoading(true);
      const result = await apollo.query({
        query: PreCancelDoc,
        variables: {
          input: {
            subscriptionId: Number(subscription?.id),
            callbackUrl,
            cancelUrl: `${callbackUrl}?refresh=true`,
          },
        },
        fetchPolicy: 'cache-first',
      });

      if (result?.errors) {
        throw result?.errors?.[0];
      }
      const preCancelUrl: string = result?.data?.preCancel?.url || defaultCancelUrl;
      window.open(preCancelUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      captureExceptionEvent(error);
      window.open(defaultCancelUrl, '_blank', 'noopener,noreferrer');
    } finally {
      setLoading(false);
    }
  }, [defaultCancelUrl, apollo, subscription, callbackUrl]);

  return { redirectToRetentionUrl, loading };
};
